import { useState, useEffect } from 'react';
import { getUserAccessToken, csrfGet } from '../../utils/genericUtils'
import { BACKEND_URL } from '../../config/config'

export function useDataFromEndpoint(endpointUrl) {
  const [jsonData, setJsonData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

    async function fetchData() {
      getUserAccessToken(async ({ access }) => {
          try {
            csrfGet(BACKEND_URL + endpointUrl, {
                cache: 'no-cache',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + access
                },
                referrerPolicy: 'no-referrer'
            }).then(response => {
              if(response.ok) {
                  return response.json()
              } else {
                  console.log('error 1')
              }
            }).then(data => {
              console.log('data', data)
              setJsonData(data);
            })
          } catch (error) {
            setError(error);
          } finally {
            setLoading(false);
          }
      })
    }

    fetchData();
  }, [endpointUrl]);

  return [jsonData, loading, error];
}

export default useDataFromEndpoint;